export default {
  sections: {
    address: 'Indirizzo',
    legal_address: 'Indirizzo di registrazione',
    invoice_address: 'Indirizzo di fatturazione',
  },
  form: {
    display_name: {
      label: 'Nome descrittivo',
      placeholder: "Inserisci il nome descrittivo dell'azienda",
    },
    legal_name: {
      label: 'Ragione sociale',
      placeholder: 'Inserisci la ragione sociale',
      tooltip: 'Nome di registrazione. Visualizzato nei report di pagamento, contratto, ecc.',
    },
    timezone: {
      label: 'Fuso orario',
    },
    has_dedicated_invoice_address: {
      label: 'Dati di fatturazione diversi',
    },
  },
  buttons: {
    next: 'Avanti',
  },
};
